import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TeamingList } from '../../CaptureCompanyLinksPanel';
import { useCaptureWorkspace } from '../../hooks';
import { TeamingAgreements } from '../../TeamingAgreements';
import { TeamingCandidates } from '../../TeamingCandidates';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/**
 * Teaming: teaming links beside candidates and agreements (OD-23: not
 * consolidated). The components are re-used, not forked, so GRW-37 can swap
 * their pickers in place.
 */ export function TeamingSection() {
    const { captureProjectId, correlationId } = usePursuitRecord();
    // GRW-30: sections always sit in the record shell, so the gate is the header capabilities.
    const { canEdit } = usePursuitRecord().capabilities;
    const { data } = useCaptureWorkspace(captureProjectId);
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        title: "Teaming",
        children: [
            /*#__PURE__*/ _jsx(TeamingList, {
                readOnly: !canEdit,
                captureProjectId: captureProjectId,
                correlationId: correlationId,
                links: data?.teamingLinks ?? []
            }),
            /*#__PURE__*/ _jsx(TeamingCandidates, {
                readOnly: !canEdit,
                captureProjectId: captureProjectId
            }),
            /*#__PURE__*/ _jsx(TeamingAgreements, {
                readOnly: !canEdit,
                captureProjectId: captureProjectId
            })
        ]
    });
}
